<template>
  <section class="account-bill-mobile" :aria-busy="isLoading">
    <h2>{{ $t('views.account_center.bill') }}</h2>
    <el-skeleton v-if="isLoading && !rows.length" animated :rows="6" class="bill-loading" />
    <ul v-else-if="rows.length" class="bill-list">
      <li v-for="row in rows" :key="row.id" class="bill-row">
        <h3>{{ row.name }}<el-text v-if="row.order_status !== 1" type="danger">{{ $t('views.account_center.unpaid') }}</el-text></h3>
        <dl>
          <div><dt>{{ $t('views.account_center.date') }}</dt><dd>{{ row.date }}</dd></div>
          <div><dt>{{ $t('views.account_center.amount') }}</dt><dd>{{ formatAmount(row) }}</dd></div>
        </dl>
        <div class="bill-invoice"><span>{{ $t('views.account_center.invoice') }}</span><slot name="invoice" :row="row" /></div>
      </li>
    </ul>
    <el-empty v-else-if="!loadError" />
    <div class="bill-load-status" aria-live="polite">
      <span v-if="isLoadingMore">{{ $t('views.account_center.loading_more') }}</span>
      <template v-else-if="loadError">
        <span>{{ $t('layout.layout.navigation_load_failed') }}</span>
        <el-button link type="primary" @click="$emit('retry')">{{ $t('layout.layout.navigation_retry') }}</el-button>
      </template>
      <span v-else-if="rows.length && !hasMore">{{ $t('views.account_center.no_more_records') }}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MobileAccountBill',
  props: {
    rows: { type: Array, default: () => [] },
    isLoading: Boolean,
    isLoadingMore: Boolean,
    loadError: Boolean,
    hasMore: Boolean,
    formatAmount: { type: Function, required: true }
  },
  emits: ['load-more', 'retry'],
  data() { return { scrollHost: null, scrollFrame: null } },
  watch: {
    'rows.length'() { this.scheduleScrollCheck() },
    isLoading(value) { if (!value) this.scheduleScrollCheck() },
    isLoadingMore(value) { if (!value) this.scheduleScrollCheck() }
  },
  mounted() {
    let host = this.$el.parentElement
    while (host && !/(auto|scroll)/.test(window.getComputedStyle(host).overflowY)) host = host.parentElement
    this.scrollHost = host || window
    this.scrollHost.addEventListener('scroll', this.checkScrollEnd, { passive: true })
    window.addEventListener('resize', this.scheduleScrollCheck)
    this.scheduleScrollCheck()
  },
  beforeUnmount() {
    this.scrollHost?.removeEventListener('scroll', this.checkScrollEnd)
    window.removeEventListener('resize', this.scheduleScrollCheck)
    if (this.scrollFrame !== null) window.cancelAnimationFrame(this.scrollFrame)
  },
  methods: {
    scheduleScrollCheck() {
      if (this.scrollFrame !== null) window.cancelAnimationFrame(this.scrollFrame)
      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = null
        this.checkScrollEnd()
      })
    },
    checkScrollEnd() {
      if (!this.rows.length || this.isLoading || this.isLoadingMore || this.loadError || !this.hasMore || !this.scrollHost) return
      const bottom = this.scrollHost === window
        ? window.innerHeight
        : this.scrollHost.getBoundingClientRect().top + this.scrollHost.clientTop + this.scrollHost.clientHeight
      if (this.$el.getBoundingClientRect().bottom - bottom <= 80) this.$emit('load-more')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../styles/bill';
</style>
